// A client-based linkResolver is needed in order to enable the preview feature
const { registerLinkResolver } = require('gatsby-source-prismic-graphql')
const { linkResolver } = require('./src/utils/linkResolver')
registerLinkResolver(linkResolver)
